// extracted by mini-css-extract-plugin
module.exports = {"item__value":"StatisticsItem-module--item__value--iF5fw"};